import { createSyncedSessionManager } from './syncedSessionManager';
import { SyncedSessionClient } from './syncedSessionClient';
export { CMD, encodeFileChange, encodeTimecode, parseMessage } from './commands';
export { SyncedSessionClient, RECONNECT_DELAY_MS, deriveSocketBaseUrl } from './syncedSessionClient';
export { createSyncedSessionManager, TCREQ_COOLDOWN_MS } from './syncedSessionManager';
/**
 * Read the Synced Session context from the legacy `window.hasSession` /
 * `window.isSessionOwner` globals that PHP sets in `player.php`. Returns
 * `{ enabled: false, role: 'leader' }` when there is no session — the
 * role is irrelevant in that case.
 */
export function readSyncedSessionContextFromWindow() {
    const w = (typeof window !== 'undefined' ? window : {});
    const enabled = !!w.hasSession;
    const role = w.isSessionOwner ? 'leader' : 'follower';
    return { enabled, role };
}
/**
 * One-shot bootstrap: reads the legacy globals, creates a client + manager,
 * connects, and caches the result on `window.hekateSyncedSession` for the
 * column manager and player to consume.
 *
 * Returns `null` when there is no active session, so callers don't have to
 * branch on `window.hasSession` themselves.
 */
export function mountSyncedSession(initialFileId) {
    const context = readSyncedSessionContextFromWindow();
    if (!context.enabled)
        return null;
    const client = new SyncedSessionClient();
    const manager = createSyncedSessionManager({ context, transport: client.asTransport() });
    const fileId = initialFileId ?? (typeof window !== 'undefined' ? window.fileID : undefined) ?? 0;
    manager.connect(fileId);
    client.start();
    const result = { manager, client, context };
    if (typeof window !== 'undefined') {
        window.hekateSyncedSession = result;
    }
    return result;
}
if (typeof window !== 'undefined') {
    window.mountSyncedSession = mountSyncedSession;
}
